import { ROUTE_PATH } from 'common/constants/sm-constants';
import { GridMetaModel } from 'common/models/utility-models/meta-model';

export class studentAssignmentGridMetaModel extends GridMetaModel<Headers> {
  constructor() {
    super(
      'Assignment',
      ROUTE_PATH.studentAssignment,
      '',
      false,
      false,
      8,
      false,
      false
    );
  }
  override initProperties() {
    const dataInfo = super.initProperties();
    const details={
         StudentCompletedAssignmentDetails:[]=[],
      StudentInCompletedAssignmentDetails:[]=[],
      StudentToDoAssignmentDetails:[]=[],
      StudentUpcomingAssignmentDetails:[]=[]
    };
     
    dataInfo.details=details;
    return dataInfo;
  }

  prepareHeaderList(): Headers[] {
    const headers: Headers[] = [];

    return headers;
  }
}
